import AgePage from '../../components/Pages/AgePage';
import { pages } from '../pageTypes';
import PageWrapper from './PageWrapper';

export default function AgePageWrapper({ serviceId, cityId, ageId }) {
  const shouldBePage = pages.age;
  const conditionTypes = {
    page: true,
    service: true,
    franchise: true,
    age: true,
  };

  return (
    <PageWrapper
      pageToLoad={<AgePage />}
      shouldBePage={shouldBePage}
      serviceId={serviceId}
      cityId={cityId}
      ageId={ageId}
      conditions={conditionTypes}
    />
  );
}
